import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, LogIn, Shield } from "lucide-react";
import { api } from "@/lib/api";
import { setSession } from "@/lib/auth";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setSession(r.data);
      nav("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Gagal masuk. Coba lagi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="auth-shell">
      <Link to="/" className="auth-back" data-testid="back-to-dashboard">
        <ArrowLeft size={16} /> Kembali ke dashboard
      </Link>
      <form className="auth-card" onSubmit={submit} data-testid="login-form">
        <div className="auth-brand">
          <Shield size={22} />
          <div>
            <b>Portal Admin BPBD</b>
            <span>SITAKO · Kabupaten Kayong Utara</span>
          </div>
        </div>
        <h1>Masuk ke ruang kendali</h1>
        <p>
          <b>SITAKO</b> — Sistem Informasi Terpadu Antisipasi Kebencanaan Online.
          Hanya petugas berwenang yang dapat mengubah ambang risiko dan
          menerbitkan laporan kejadian.
        </p>
        <label>
          <span>Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@bpbd-kku.go.id"
            data-testid="login-email"
          />
        </label>
        <label>
          <span>Kata sandi</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            data-testid="login-password"
          />
        </label>
        {error && (
          <div className="auth-error" data-testid="login-error">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          className="auth-submit"
          data-testid="login-submit"
        >
          <LogIn size={16} /> {loading ? "Memverifikasi..." : "Masuk"}
        </button>
      </form>
    </main>
  );
}
